"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 视频流缓存 管理 已下载的视频流
 */
var BufferCache = function () {
    function BufferCache() {
        _classCallCheck(this, BufferCache);

        this.BufferedSegments = {};
        this.temporaryBufferedSegments = {};
        this.InitArrayBuffer = new ArrayBuffer();
        this.VideoSIDX = {};
    }

    _createClass(BufferCache, [{
        key: "getSegmentArrayBufferByIndex",
        value: function getSegmentArrayBufferByIndex(index) {
            return this.BufferedSegments[index];
        }
    }, {
        key: "pushSegment",
        value: function pushSegment(sourceBuffer, Segment) {
            this.BufferedSegments[Segment.index] = Segment.segmentArrayBuffer;
            if (!sourceBuffer.updating) {
                sourceBuffer.appendBuffer(new Uint8Array(Segment.segmentArrayBuffer));
            } else {
                this.temporaryBufferedSegments[Segment.index] = Segment.segmentArrayBuffer;
            }
        }
        /**
         * 检测该号码的分片是否已缓存
         * @param index
         * @returns {*}
         * @constructor
         */

    }, {
        key: "IsBufferedSegmentIndex",
        value: function IsBufferedSegmentIndex(index) {
            return this.BufferedSegments.hasOwnProperty(index);
        }
    }]);

    return BufferCache;
}();

exports.default = BufferCache;


//////////////////
// WEBPACK FOOTER
// ./~/somi-dashjs/dist/BufferCache.js
// module id = 16
// module chunks = 0